import { InputAdornment, TextField } from '@mui/material';
import * as React from 'react';
import { NumericFormat, NumericFormatProps } from 'react-number-format';

interface CustomProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
  }
  
const NumericFormatCustom = React.forwardRef<NumericFormatProps, CustomProps>(
    function NumericFormatCustom(props, ref) {
        const { onChange, ...other } = props;

        return (
        <NumericFormat
            {...other}
            getInputRef={ref}
            onValueChange={(values) => {
            onChange({
                target: {
                name: props.name,
                value: values.value,
                },
            });
            }}
            thousandSeparator={'.'}
            decimalScale={0}
            decimalSeparator={','}
            inputMode='numeric'
        />
        );
    }
);

interface NumericInputProps{
    value?: number
    onChange: (event: { target: { name: string; value: string } }) => void;
}
  
const NumericInput:React.FC<NumericInputProps> = (props) => {
  const handleKeyPress = (e: any) => {
    if(!/[0-9Backspace]/.test(e.key)){
        e.preventDefault()
        return;
    }
  };
    return ( 
    <TextField sx={{width:'100%'}}
        label="Sueldo bruto"
        value={props.value}
        onChange={props.onChange}
        placeholder="0"
        name="numberformat"
        inputMode='numeric'
        onKeyDown={handleKeyPress}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">$</InputAdornment>
          ),
          inputComponent: NumericFormatCustom as any,
        }}
        variant="outlined"
        helperText="Ejemplo: $1.000.000"
      /> );
}
 
export default NumericInput;